import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51c9196a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("创建规则")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%"} }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  'GET/checkin_punch_rules': fetchList,
  // delete rule
  'DELETE/checkin_punch_rules/{id}': delRuleApi,
  // create rule
  'POST/checkin_punch_rules': createRuleApi,
  // edit rule
  'PATCH/checkin_punch_rules': editRuleApi,
 } = Api

const { MI_tableData, fetchData, MI_identify, MI_height } = new tbMix(fetchList)
fetchData()

// 创建
const addRuleForm: any = ref()
const isShowCreate = ref<boolean>(false)
const btnFg = ref<boolean>(false)
const addConfig = reactive({
  morningStart: '',
  morningEnd: '',
  nonoStart: '',
  nonoEnd: '',
  afternoonStart: '',
  afternoonEnd: '',
  place: '',
  scope: '',
  freedom: 1,
  id: '',
  name: '',
  sort: '',
})
const rules = reactive({
  morningStart: [ { required: true, message: '不能为空', trigger: 'change' } ],
  morningEnd: [ { required: true, message: '不能为空', trigger: 'change' } ],
  nonoStart: [ { required: true, message: '不能为空', trigger: 'change' } ],
  nonoEnd: [ { required: true, message: '不能为空', trigger: 'change' } ],
  afternoonStart: [ { required: true, message: '不能为空', trigger: 'change' } ],
  afternoonEnd: [ { required: true, message: '不能为空', trigger: 'change' } ],
  place: [ { required: true, message: '不能为空', trigger: 'change' } ],
  scope: [ { required: true, message: '不能为空', trigger: 'change' } ],
  freedom: [ { required: true, message: '不能为空', trigger: 'change' } ],
  name: [ { required: true, message: '不能为空', trigger: 'change' } ],
})

const addHandle = () => {
  addRuleForm.value.validate(async(valid: boolean) => {
    if (valid) {
      addConfig.id = ''
      await createRuleApi(addConfig)
      ElMessage.success('添加成功')
      isShowCreate.value = false
      fetchData()
    } else {
      return false
    }
  })
}

const editFg = ref<boolean>(false)
const editHandle = (row: object) => {
  Object.assign(addConfig, row)
  editFg.value = true
}

const editSubmit = () => {
  addRuleForm.value.validate(async(valid: boolean) => {
    if (valid) {
      await editRuleApi(addConfig)
      ElMessage.success('编辑成功')
      editFg.value = false
      fetchData()
    } else {
      return false
    }
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm('确认删除？', '提示', {type: 'warning'})
    .then(() => {
      MI_identify.value = true
      return delRuleApi({id: row.id})
    })
    .then(() => {
      ElMessage.success('删除成功')
      MI_identify.value = false
      fetchData()
    })
    .catch(() => {
      MI_identify.value = false
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_time_select = _resolveComponent("el-time-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowCreate.value = true)),
        disabled: _unref(MI_identify)
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        type: "info",
        icon: "refresh",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)())),
        disabled: _unref(MI_identify)
      }, null, 8, ["disabled"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      "max-height": _unref(MI_height) + 'px',
      data: _unref(MI_tableData)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "规则名称",
          prop: "name"
        }),
        _createVNode(_component_el_table_column, {
          label: "排序",
          prop: "sort"
        }),
        _createVNode(_component_el_table_column, {
          label: "早上打卡起",
          prop: "morningStart"
        }),
        _createVNode(_component_el_table_column, {
          label: "早上打卡止",
          prop: "morningEnd"
        }),
        _createVNode(_component_el_table_column, {
          label: "中午休息开始",
          prop: "nonoStart"
        }),
        _createVNode(_component_el_table_column, {
          label: "中午休息结束",
          prop: "nonoEnd"
        }),
        _createVNode(_component_el_table_column, {
          label: "下午打卡起",
          prop: "afternoonStart"
        }),
        _createVNode(_component_el_table_column, {
          label: "下午打卡止",
          prop: "afternoonEnd"
        }),
        _createVNode(_component_el_table_column, {
          label: "地点",
          prop: "place",
          "show-overflow-tooltip": "",
          "min-width": "140"
        }),
        _createVNode(_component_el_table_column, {
          label: "作用域",
          prop: "scope"
        }),
        _createVNode(_component_el_table_column, {
          label: "自由度",
          prop: "freedom"
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  type: "primary",
                  onClick: ($event: any) => (editHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["max-height", "data"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowCreate.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((isShowCreate).value = $event)),
      width: "820",
      onClose: _cache[15] || (_cache[15] = ($event: any) => (addRuleForm.value.resetFields())),
      title: "创建规则"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (isShowCreate.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (addHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addRuleForm",
          ref: addRuleForm,
          rules: _unref(rules),
          "label-width": "200px",
          "label-position": "top",
          model: _unref(addConfig),
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "规则名称:",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addConfig).name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(addConfig).name) = $event)),
                  class: "form-input",
                  placeholder: "请输入规则名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "地点:",
              prop: "place"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addConfig).place,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(addConfig).place) = $event)),
                  placeholder: "请输入地点",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "作用域:",
              prop: "scope"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addConfig).scope,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(addConfig).scope) = $event)),
                  placeholder: "请输入作用域",
                  class: "form-input"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tooltip, {
                  class: "tooltip",
                  content: "规则作用员工范围（员工/高管）",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "ml-10" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "自由度:",
              prop: "freedom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  controls: false,
                  modelValue: _unref(addConfig).freedom,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addConfig).freedom) = $event)),
                  min: 0,
                  class: "form-input"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tooltip, {
                  class: "tooltip",
                  content: "0-1之间。1：为按照考勤规则上下班。0.8为有20%的自主调配时间，只需要满足80%的考勤时间即可。",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "ml-10" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: "早上打卡起:",
              prop: "morningStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  modelValue: _unref(addConfig).morningStart,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addConfig).morningStart) = $event)),
                  start: "00:00",
                  step: "00:10",
                  end: "14:00",
                  placeholder: "早上打卡起"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "早上打卡止:",
              prop: "morningEnd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  modelValue: _unref(addConfig).morningEnd,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addConfig).morningEnd) = $event)),
                  start: "00:00",
                  step: "00:10",
                  end: "14:00",
                  placeholder: "早上打卡止"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_5,
            _createVNode(_component_el_form_item, {
              label: "中午休息开始:",
              prop: "nonoStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  modelValue: _unref(addConfig).nonoStart,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addConfig).nonoStart) = $event)),
                  start: "10:00",
                  step: "00:10",
                  end: "16:00",
                  placeholder: "中午休息开始"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "中午休息结束:",
              prop: "nonoEnd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  modelValue: _unref(addConfig).nonoEnd,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addConfig).nonoEnd) = $event)),
                  start: "10:00",
                  step: "00:10",
                  end: "16:00",
                  placeholder: "中午休息结束"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_6,
            _createVNode(_component_el_form_item, {
              label: "下午打卡起:",
              prop: "afternoonStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  modelValue: _unref(addConfig).afternoonStart,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(addConfig).afternoonStart) = $event)),
                  start: "12:00",
                  step: "00:10",
                  end: "23:00",
                  placeholder: "下午打卡起"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "下午打卡止:",
              prop: "afternoonEnd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  modelValue: _unref(addConfig).afternoonEnd,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(addConfig).afternoonEnd) = $event)),
                  start: "12:00",
                  step: "00:10",
                  end: "23:00",
                  placeholder: "下午打卡止"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((editFg).value = $event)),
      width: "820",
      onClose: _cache[30] || (_cache[30] = ($event: any) => (addRuleForm.value.resetFields())),
      title: "编辑规则"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[27] || (_cache[27] = ($event: any) => (editFg.value = false)),
          disabled: btnFg.value
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["disabled"]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: _cache[28] || (_cache[28] = ($event: any) => (editSubmit()))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })), [
          [_directive_loading, btnFg.value]
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "addRuleForm",
          ref: addRuleForm,
          rules: _unref(rules),
          "label-position": "top",
          model: _unref(addConfig),
          inline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "规则名称:",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addConfig).name,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(addConfig).name) = $event)),
                  class: "form-input",
                  placeholder: "请输入规则名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "地点:",
              prop: "place"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addConfig).place,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(addConfig).place) = $event)),
                  placeholder: "请输入地点",
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "排序:",
              prop: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  controls: false,
                  modelValue: _unref(addConfig).sort,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(addConfig).sort) = $event)),
                  min: 0,
                  class: "form-input"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "作用域:",
              prop: "scope"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(addConfig).scope,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(addConfig).scope) = $event)),
                  placeholder: "请输入作用域",
                  class: "form-input"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tooltip, {
                  class: "tooltip",
                  content: "规则作用员工范围（员工/高管）",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "ml-10" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "自由度:",
              prop: "freedom"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  controls: false,
                  modelValue: _unref(addConfig).freedom,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(addConfig).freedom) = $event)),
                  min: 0,
                  class: "form-input"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_tooltip, {
                  class: "tooltip",
                  content: "0-1之间。1：为按照考勤规则上下班。0.8为有20%的自主调配时间，只需要满足80%的考勤时间即可。",
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { class: "ml-10" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_QuestionFilled)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, {
              label: "早上打卡起:",
              prop: "morningStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  class: "form-input",
                  modelValue: _unref(addConfig).morningStart,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(addConfig).morningStart) = $event)),
                  start: "00:00",
                  step: "00:10",
                  end: "14:00",
                  placeholder: "早上打卡起"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "早上打卡止:",
              prop: "morningEnd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  class: "form-input",
                  modelValue: _unref(addConfig).morningEnd,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(addConfig).morningEnd) = $event)),
                  start: "00:00",
                  step: "00:10",
                  end: "14:00",
                  placeholder: "早上打卡止"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_9,
            _createVNode(_component_el_form_item, {
              label: "中午休息开始:",
              prop: "nonoStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  class: "form-input",
                  modelValue: _unref(addConfig).nonoStart,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(addConfig).nonoStart) = $event)),
                  start: "10:00",
                  step: "00:10",
                  end: "16:00",
                  placeholder: "中午休息开始"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "中午休息结束:",
              prop: "nonoEnd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  class: "form-input",
                  modelValue: _unref(addConfig).nonoEnd,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(addConfig).nonoEnd) = $event)),
                  start: "10:00",
                  step: "00:10",
                  end: "16:00",
                  placeholder: "中午休息结束"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _hoisted_10,
            _createVNode(_component_el_form_item, {
              label: "下午打卡起:",
              prop: "afternoonStart"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  class: "form-input",
                  modelValue: _unref(addConfig).afternoonStart,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(addConfig).afternoonStart) = $event)),
                  start: "12:00",
                  step: "00:10",
                  end: "23:00",
                  placeholder: "下午打卡起"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "下午打卡止:",
              prop: "afternoonEnd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_time_select, {
                  class: "form-input",
                  modelValue: _unref(addConfig).afternoonEnd,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(addConfig).afternoonEnd) = $event)),
                  start: "12:00",
                  step: "00:10",
                  end: "23:00",
                  placeholder: "下午打卡止"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})